import PropTypes from 'prop-types'
import { Handle, Position, useUpdateNodeInternals } from '@xyflow/react'
import { useEffect, useRef, useState, useContext } from 'react'
import { isValidConnection } from '@/utils/genericHelper'
// project import
import { FlowContext } from '@/store/context/ReactFlowContext'

const NodeInputControlHandler = ({ inputControl, data }) => {
    const ref = useRef<HTMLDivElement | null>(null)
    const { reactFlowInstance } = useContext(FlowContext)
    const updateNodeInternals = useUpdateNodeInternals()
    const [position, setPosition] = useState<number>(0)

    useEffect(() => {
        if (ref.current) {
            setPosition(ref.current.offsetTop + ref.current.clientHeight / 2)
            updateNodeInternals(data.id)
        }
    }, [ref, updateNodeInternals])

    useEffect(() => {
        updateNodeInternals(data.id)
    }, [position, updateNodeInternals])

    return (
        // <div  className="float-left">
        //     <div className="relative">
        //         <div className="absolute -left-4 top-1/2 transform -translate-y-1/2"> 
                    <div ref={ref} className="flex flex-row" data-tip={inputControl.label}>
                        <Handle
                            type="target"
                            position={Position.Left}
                            id={inputControl.id}
                            className="h-2.5 w-2.5 bg-red-500 rounded-full"
                            style={{ 
                                height: "10px",width: "10px", backgroundColor: "red", borderRadius: "100%", top: position   }}
                            isValidConnection={(connection) => isValidConnection(connection, reactFlowInstance)}
                        />
                         <div className="p-2 w-full">
                            <p>{inputControl.name}</p>
                        </div>
                    </div>
        //         </div>
        //     </div>
        // </div>
    )
}

NodeInputControlHandler.propTypes = {
    inputAnchor: PropTypes.object,
    inputParam: PropTypes.object,
    inputControl: PropTypes.object,
    data: PropTypes.object,
    disabled: PropTypes.bool,
    isAdditionalParams: PropTypes.bool
}

export default NodeInputControlHandler
